
<template>

  <select-input
  :label="label"
  v-model="formData"
  value-key="value"
  label-value="label"
  :placeholder="placeholder"
  :size="size"
  :list="selectData"
  :required="required"
  :disabled="disabled"
  @change="ticketUpdated" />

</template>

<script>

export default {
  name: 'select-ticket-category',

  props: {
    label: {
      type: String,
      default: 'Ticket Category'
    },
    value: {
      //      type: String,
      required: true
    },
    prop: {
      type: String,
      default () { return this.label }
    },
    size: {
      type: String,
      default: 'normal'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    }
  },


  methods: {
    ticketUpdated (value) {
      this.formData = value
      this.$emit('input', this.formData)
      this.$emit('change', this.formData)
    }
  },

  data () {
    return {
      formData: this.value,
      selectData: this.getConfig().selects.ticketCategory
    }
  }
}
</script>
